export default __webpack_public_path__ + "static/media/iterBox.d0f90a84.png";